import * as z from "zod";

export const emailSubscribeSchema = z.object({
    email: z.string().email().min(1, { message: "Email is required" }),
    termsAndPrivacyOptIn: z.boolean().refine(value => value === true, { message: "Terms and Privacy opt in is required" }),
    shareEmailWithUserOptIn: z.boolean().optional(),
})

export const emailSubscribeBackendSchema = z.object({
    email: z.string().email().min(1, { message: "Email is required" }),
    termsAndPrivacyOptIn: z.boolean().refine(value => value === true, { message: "Terms and Privacy opt in is required" }),
    shareEmailWithUserOptIn: z.boolean().optional(),
    userId: z.string().min(1).max(100),
    isSubscribePageAfterReview: z.boolean().optional(),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
})

export const checkoutSubscribeSchema = z.object({
    email: z.string().email().min(1, { message: "Email is required" }),
    firstName: z.string().min(1, { message: "First name is required" }),
    lastName: z.string().min(1, { message: "Last name is required" }),
    shareEmailWithUserOptIn: z.boolean().optional(),
})